import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Form, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  getOptionsFromRefList,
  getRefListNameByID,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const BailInformation = ({ formData, form, isEdit, bookingBails }) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  const [bookingBailsOptions, setBookingBailsOption] = useState([]);

  useEffect(() => {
    if (bookingBails?.length) {
      const optionsBookingBail = [];

      bookingBails?.forEach((element) => {
        optionsBookingBail.push({
          value: element?.bookingBailID || element?.bookingBailUuid,
          label: `$ ${element?.bailAmount}, Bail Type: ${
            isNonEmptyVariable(element?.bailTypeID)
              ? getRefListNameByID("BondType", element?.bailTypeID)
              : ""
          } ${
            isNonEmptyVariable(element?.courtNumber)
              ? "( " + element?.courtNumber + " )"
              : ""
          } `,
        });
      });
      setBookingBailsOption(() => optionsBookingBail);

      if (
        isEdit &&
        isNonEmptyVariable(formData?.bookingBails) &&
        formData?.bookingBails?.length &&
        (isNonEmptyVariable(formData?.bookingBails?.[0]?.bookingBailUuid) ||
          isNonEmptyVariable(formData?.bookingBails?.[0]?.bookingBailID))
      ) {
        form.setFieldValue("chooseBailType", "Attach_existing_bail");
        form.setFieldValue(
          "bookingBailUuid",
          formData?.bookingBails?.[0]?.bookingBailID ||
            formData?.bookingBails?.[0]?.bookingBailUuid
        );
      } else {
        form.setFieldValue("chooseBailType", "");
        form.setFieldValue("bookingBailUuid", "");
      }
    }
  }, [bookingBails]);

  const chooseBailType = Form.useWatch("chooseBailType", form);
  const bailTypeID = Form.useWatch(["bookingBails", 0, "bailTypeID"], form);
  useEffect(() => {
    if (chooseBailType == "new_bail") {
      form.setFieldValue(["bookingBails", 0, "bailTypeID"], "");
      form.setFieldValue(
        ["bookingBails", 0, "creatorStaffID"],
        userDetails?.staffId
      );
      form.setFieldValue(["bookingBails", 0, "bailAmount"], "");
      form.setFieldValue(["bookingBails", 0, "requiredPaymentTypeID"], "");
      form.setFieldValue(["bookingBails", 0, "comments"], "");
    }
  }, [chooseBailType]);

  useEffect(() => {
    if (isNonEmptyVariable(bailTypeID) && bailTypeID === 51320003) {
      form.setFieldValue(["bookingBails", 0, "bailAmount"], "0");
    } else {
      form.setFieldValue(["bookingBails", 0, "bailAmount"], "");
    }
  }, [bailTypeID]);
  return (
    <>
      <IntakeSectionHeader>
        <span>Bail Information</span>
      </IntakeSectionHeader>
      <p>
        Select whether you want to create a new bail or attach to an existing
        bail
      </p>
      <FormContainer>
        <Row gutter={16}>
          <Col span={10}>
            <FormItem
              name="chooseBailType"
              label="Bail Option Mode"
              layout="vertical"
            >
              <Select
                options={[
                  { value: "new_bail", label: "Create new Bail" },
                  {
                    value: "Attach_existing_bail",
                    label: "Attach to an existing bail",
                  },
                ]}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
        </Row>

        <Row gutter={16}>
          {chooseBailType == "Attach_existing_bail" && (
            <Col span={6}>
              <FormItem
                name="bookingBailUuid"
                label="Select Bail"
                layout="vertical"
              >
                <Select
                  options={bookingBailsOptions}
                  placeholder="Select Exising Bail"
                  variant="outlined"
                />
              </FormItem>
            </Col>
          )}
          {chooseBailType == "new_bail" && (
            <>
              <Col span={6}>
                <FormItem
                  name={["bookingBails", 0, "bailTypeID"]}
                  label="Bond Type"
                  layout="vertical"
                >
                  <Select
                    options={getOptionsFromRefList(
                      "BondType",
                      false,
                      false,
                      true
                    )}
                    placeholder="Bond Type"
                    variant="outlined"
                  />
                </FormItem>
              </Col>
              <Col span={6} hidden={true}>
                <FormItem
                  name={["bookingBails", 0, "creatorStaffID"]}
                  label="Creator Staff ID"
                  layout="vertical"
                  defaultValue={userDetails?.staffId}
                >
                  <TextField />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name={["bookingBails", 0, "bailAmount"]}
                  label="Amount"
                  layout="vertical"
                >
                  <TextField />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  name={["bookingBails", 0, "requiredPaymentTypeID"]}
                  label="Required Payment Type"
                  layout="vertical"
                >
                  <Select
                    options={getOptionsFromRefList(
                      "Payment_Type",
                      false,
                      false,
                      true
                    )}
                    placeholder="Payment Type"
                    variant="outlined"
                  />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem
                  name={["bookingBails", 0, "comments"]}
                  label="Comments"
                  layout="vertical"
                >
                  <TextField inputType="textarea" rows={5} />
                </FormItem>
              </Col>
            </>
          )}
        </Row>
      </FormContainer>
    </>
  );
};

export default BailInformation;
